import secureLocalStorage from 'react-secure-storage';
import { HttpRequest } from '../../components/HttpRequest';

export const evouchersApi = {
  async getActiveCampaigns({ limit = 100, page = 1 } = {}) {
    const businessNumber = secureLocalStorage.getItem('businessId');
    const data = await HttpRequest({
      method: 'GET',
      url: `/api/v1/ecommerce/voucher_campaigns?businessNumber=${businessNumber}&limit=${limit}&page=${page}&status=Active`,
    });
    if (data?.status !== 200) {
      throw new Error(data?.response?.message || 'Failed to load voucher campaigns');
    }
    return data?.response?.data || [];
  },
};
